// redux/slices/chatSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { startChatSession } from '../../api/api';

// 🔄 Async thunk: init chat session
export const initChatSession = createAsyncThunk(
  'chat/initChatSession',
  async ({ chatId, uid, title }, { rejectWithValue }) => {
    try {
      const session = await startChatSession({
        uid,
        chat_session_id: '',
        title,
      });
      return { chatId, sessionId: session.chat_session_id };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    sessions: {},
  },
  reducers: {
    resetChatSession: (state, action) => {
      const chatId = action.payload;
      delete state.sessions[chatId];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initChatSession.fulfilled, (state, action) => {
        const { chatId, sessionId } = action.payload;
        state.sessions[chatId] = sessionId;
      })
      .addCase(initChatSession.rejected, (state, action) => {
        console.error('Failed to init chat session:', action.payload);
      });
  },
});

export const { resetChatSession } = chatSlice.actions;
export default chatSlice.reducer;
